export const thirdPartyDocumentationCatalog = [
    {
        title: 'Becoming a partner',
        description: 'How do you become a Sparebank 1 partner developer.',
        urlExtension: 'partner',
    },
    {
        title: 'Partners and PSD2 developers',
        description: 'What is the difference between PSD2- and Partner developers?',
        urlExtension: 'developerTypes',
    },
    {
        title: 'OAuth authentication flow',
        description: 'How to authenticate client using OAuth',
        urlExtension: 'partnerOAuthFlow',
    },
    {
        title: 'Federated authentication flow',
        description: 'How to authenticate client using Federated authentication',
        urlExtension: 'partnerFederatedFlow',
    },
    {
        title: 'Certificate authentication flow',
        description: 'How to authenticate client using a certificate',
        urlExtension: 'partnerCertificateFlow',
    },
]

export const validPaths = thirdPartyDocumentationCatalog.map((it) => it.urlExtension)
